// extracted by mini-css-extract-plugin
var _1 = "UserAvatar-moduleUserAvatar__ajfm8";
export { _1 as "UserAvatar" }
